import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import logo from "assets/images/logo.png";
import Alert from "@mui/material/Alert";
import {useEffect, useState} from "react";
import {useParams, useNavigate} from "react-router-dom";
import { UpdatePassword } from "../../../axios-client";
import CircularProgress from "@mui/material/CircularProgress";
import {Box, Grid, Typography} from "@mui/material";
import LanguageSwitcher from "../../../reusableComponents/LanguageSwitcher/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import {setLayout} from "../../../store/actions/app-actions";
import {useSoftUIController} from "../../../context";
import background from "../../../assets/images/curved-images/background.jpg";
function ResetNewPassword() {
    const {token} = useParams();
    const theme = useTheme();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [controller, dispatch] = useSoftUIController();

    const {i18n} = useTranslation();
    const { t } = useTranslation(['resetPassword']);
    const currentLang = i18n.language;
    const signInPage = `/${currentLang}/authentication/sign-in`;
    const [animateTitle, setAnimateTitle] = useState(false);
    const [animateImage, setAnimateImage] = useState(false);

    useEffect(() => {
        setTimeout(() => setAnimateImage(true), 300);
        setTimeout(() => setAnimateTitle(true), 500);
        setLayout(dispatch, "page");
    }, []);


    const handleResetPassword = async (event) => {
        event.preventDefault();

        setErrorMessage(null);
        setSuccessMessage(null);

        if (!newPassword || !confirmPassword) {
            setErrorMessage(t('changePassword.error.both'));
            return;
        }

        if (newPassword !== confirmPassword) {
            setErrorMessage(t('changePassword.error.match'));
            return;
        }

        try {
            await UpdatePassword(token, newPassword, confirmPassword);
            setSuccessMessage(t('changePassword.success'));
            setIsLoading(true);
            setTimeout(() => navigate(signInPage), 3000);
        } catch (error) {
            if (error.response && error.response.data) {
                if (error.response.data.error) {
                    setErrorMessage(error.response.data.error);
                } else if (error.response.data.message) {
                    setErrorMessage(error.response.data.message);
                } else {
                    setErrorMessage("An error occurred, please try again later!");
                }
            } else {
                setErrorMessage("An error occurred, please try again later!");
            }
            setIsLoading(false);
        }
    };

    return (
        <>

            <Grid container sx={{minHeight: "100vh", overflow: "hidden"}}>
                {/* Left Side */}
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 5,
                        backgroundColor: "#ffffff",
                        position: "relative",
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: theme.spacing(2),
                            left: theme.spacing(2),
                            right: theme.spacing(2),
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            zIndex: 10,
                        }}
                    >
                        <Box
                            sx={{
                                transition: "all 0.8s ease",
                            }}
                        >
                            <img src={logo} alt="YaiGlobal Logo" style={{height: 48}}/>
                        </Box>

                        <LanguageSwitcher/>
                    </Box>

                    <Box sx={{width: "100%", maxWidth: 400}}>
                        <Typography
                            variant="h4"
                            fontWeight="bold"
                            sx={{
                                background: "linear-gradient(to right, #d946ef, #ec4899)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                mb: 1,
                                opacity: animateTitle ? 1 : 0,
                                transform: animateTitle ? "translateX(0)" : "translateX(-10px)",
                                transition: "all 0.7s ease",
                            }}
                        >
                            {t('title')}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{
                                mb: 3,
                                opacity: animateTitle ? 1 : 0,
                                transform: animateTitle ? "translateX(0)" : "translateX(-10px)",
                                transition: "all 0.8s ease",
                            }}
                        >
                            {t('description')}
                        </Typography>

                        {errorMessage && (
                            <Alert severity="error" onClose={() => setErrorMessage(null)}>
                                {errorMessage}
                            </Alert>
                        )}

                        {successMessage && (
                            <Alert severity="success" onClose={() => setSuccessMessage(null)}>
                                {successMessage}
                            </Alert>
                        )}

                        <SoftBox component="form" role="form" onSubmit={handleResetPassword}>
                            {isLoading && (
                                <SoftBox display="flex" justifyContent="center" my={2}>
                                    <CircularProgress size={24} />
                                </SoftBox>
                            )}
                            <SoftBox mb={2}>
                                <SoftBox mb={1} ml={0.5}>
                                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                                        {t('newPassword')}
                                    </SoftTypography>
                                </SoftBox>
                                <SoftInput
                                    type="password"
                                    placeholder={t('enterNewPassword')}
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                            </SoftBox>

                            <SoftBox mb={2}>
                                <SoftBox mb={1} ml={0.5}>
                                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                                        {t('confirmNewPassword')}
                                    </SoftTypography>
                                </SoftBox>
                                <SoftInput
                                    type="password"
                                    placeholder={t('confirmNewPassword')}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </SoftBox>

                            <SoftBox mt={4} mb={1}>
                                <SoftButton variant="gradient" color="primary" fullWidth type="submit">
                                    {t('resetPassword')}
                                </SoftButton>
                            </SoftBox>
                        </SoftBox>
                    </Box>
                </Grid>

                {/* Right Side – Decorative Panel */}
                <Grid item md={6} sx={{display: {xs: "none", md: "block"}, position: "relative", overflow: "hidden"}}>
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",
                            backgroundImage: `url(${background})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            opacity: animateImage ? 1 : 0,
                            transition: "opacity 1s ease",
                        }}
                    />

                    {/* Light Overlay to Further Brighten */}
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                        }}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default ResetNewPassword;
